module.exports = __webpack_public_path__ + "img/3.51bede67.jpg";